import { createGlobalState } from 'react-hooks-global-state';

const { setGlobalState, useGlobalState } = createGlobalState({
  totalPoints: 0,
});

export const setPoints = (points) => {
  setGlobalState('totalPoints', points);
};

export { useGlobalState };
